import React, { memo } from 'react';
import { Dialog, Button, Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';
import modules_59ffffaf from './styles/CommonError.module.less.js';

const { Text, Heading } = Typography;
const CommonError = memo((props) => {
    const { title, subTitle, onClick, icon, buttonText } = props;
    const cx = useStyles(modules_59ffffaf);
    return (React.createElement(Dialog.Content, { className: cx('wrapper') },
        icon,
        React.createElement(Heading, { level: 3, className: cx('h-mt-8') }, title),
        subTitle && React.createElement(Text, { className: "h-mt-8" }, subTitle),
        onClick && (React.createElement(Button, { className: cx('btnWrapper', 'h-mt-16'), size: 52, variant: "primary", color: "gray", onClick: onClick }, buttonText))));
});
CommonError.displayName = 'ErrorResponse';

export { CommonError };
//# sourceMappingURL=CommonError.js.map
